<template>
  <div>
    <a-modal
      :visible="show"
      :width="600"
      :footer="null"
      forceRender
      @cancel="$emit('update:show', false)"
      :bodyStyle="{
        padding: '0 16px 8px',
        maxHeight: '600px',
        overflowY: 'auto'
      }"
    >
      <template slot="title">
        <div style="text-align: center;">{{ details.name }}</div>
      </template>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="污染源信息">
          <a-row :gutter="[8, 12]">
            <a-col :span="24">
              <span class="content-title">发现时间：</span>{{ details.time }}
            </a-col>
            <a-col :span="6">
              <span class="content-title">所属河道：</span
              >{{ details.river }} </a-col
            ><a-col :span="6">
              <span class="content-title">所属街道：</span>{{ details.street }}
            </a-col>
            <a-col :span="6">
              <span class="content-title">位于左右岸：</span>{{ "" }}
            </a-col>
            <a-col :span="6">
              <span class="content-title">发生位置：</span
              >{{ details.location }}
            </a-col>
            <a-col :span="24">
              <span class="content-title">经纬度：</span>{{ details.lng }} ,
              {{ details.lat }}
            </a-col>
            <a-col :span="24">
              <span class="content-title">地理位置：</span
              >{{ details.location }}
            </a-col>
            <br />
            <a-col :span="12">
              <span class="content-title">污染类别：</span
              >{{ details.category }}
            </a-col>
            <a-col :span="12">
              <span class="content-title">污染等级：</span>{{ "一级" }}
            </a-col>
            <a-col :span="12">
              <span class="content-title">一类污染源：</span
              >{{ details.first_category }}
            </a-col>
            <a-col :span="12">
              <span class="content-title">二类污染源：</span
              >{{ details.second_category }}
            </a-col>
            <a-col :span="24">
              <span class="content-title">是否整改：</span
              >{{ details.is_reform ? "是" : "否" }}
            </a-col>
            <a-col :span="12">
              <span class="content-title">整改时间：</span
              >{{ details.reform_time }}
            </a-col>
            <a-col :span="12">
              <span class="content-title">整改人员(单位)：</span
              >{{ details.reform_person }}
            </a-col>
            <a-col :span="12">
              <span class="content-title">备注：</span>{{ details.remark }}
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2" tab="巡查日志">
          <a-button
            type="primary"
            icon="plus"
            style="margin-bottom:20px"
            @click="visible = true"
            >添加日志</a-button
          >
          <div v-for="item in logList" :key="item.id" style="margin: 10px 0;">
            <div style="padding: 8px 0">
              <span style="font-weight: 550">{{ item.name }}</span>
              <span style="margin-left: 8px;color: #ccc">{{
                item.time | timeFormatter
              }}</span>
            </div>
            <div>
              {{ item.remark }}
            </div>
            <a-row :gutter="[8, 8]">
              <span :span="8" v-for="(p, index) in item.pic_urls" :key="index">
                <el-image
                  :src="ossBaseUrl + p"
                  :preview-src-list="[ossBaseUrl + p]"
                  style="width: 150px;height: 150px;padding: 8px"
                />
              </span>
            </a-row>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <add-log
      :visible.sync="visible"
      :record="record"
      @onOk="
        v => {
          visible = v;
          getLogList();
        }
      "
    ></add-log>
  </div>
</template>

<script>
import { getPollutantDetails, getPollutantLogList } from "@/api/api";
import AddLog from "@/pages/manage/pollution_manage/components/AddLog";
import moment from "moment";
import { OSS_PIC_BASE_URL } from "@/config/config";

export default {
  data() {
    return {
      details: {},
      visible: false,
      logList: [],
      ossBaseUrl: OSS_PIC_BASE_URL
    };
  },
  components: {
    AddLog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    timeFormatter(v) {
      if (!v) {
        return "";
      }
      return moment(v).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    if (this.record.id) {
      this.getDetails();
      this.getLogList();
    }
  },
  methods: {
    async getDetails() {
      try {
        let res = await getPollutantDetails(this.record.id);
        this.details = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getLogList() {
      try {
        let res = await getPollutantLogList(this.record.id);
        this.logList = res.data.items;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.content-title {
  font-weight: 550;
}
</style>
